// import external dependencies
import 'jquery';

// Import Slick
import 'slick-carousel/slick/slick.min';

// Import Lazy Loading Images
import 'lazysizes';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import contact from './routes/contact';
import singleProduct from './routes/product'; 

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Product JS
  singleProduct,
  // contact page JS
  contact,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js